module.exports = __webpack_public_path__ + "img/home_icon_dianqi_sel.3a9c4d86.png";